import { isPresent } from 'utils/isPresent';
import React, {Component} from 'react'
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog'
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions'
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent'
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle'
import {connect} from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import ui from 'redux-ui';
import { compose } from 'redux';
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField'
import {updateOnCallAirApiKey, getOnCallAirApiKey, disableOnCallAir} from '../Models/OnCallAirModel.js'
import {setAppEnabled, setAppDisabled} from '../Redux/Actions';
export const OPEN_ON_CALL_AIR_DIALOG = 'OPEN_ON_CALL_AIR_DIALOG';
export const CLOSE_ON_CALL_AIR_DIALOG = 'CLOSE_ON_CALL_AIR_DIALOG';
export const SET_BUTTON_ENABLED = 'SET_BUTTON_ENABLED';
export const SET_ON_CALL_AIR_API_KEY = 'SET_ON_CALL_AIR_API_ID';
export const SUBMIT_FINISHED = 'SUBMIT_FINISHED';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';

class OnCallAirDialog extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getOnCallAirApiKey();
    }

    determineCallToAction() {
        let cta = '';
        if (this.props.ui.setupBookingWindows === true) {
            cta = 'Setup OnCallair'
        } else if (this.props.ui.disableButton) {
            cta = 'Submitting'
        } else {
            cta = 'Submit'
        }
        return cta
    }

    render() {

        console.log(this.props.onCallAirApiKey)

        var errorBar = null;
        if (this.props.ui.errorMessage) {
            errorBar = <div >{this.props.ui.errorMessage}</div>
        }

        var actions = null;
        if (this.props.appEnabled) {
            actions = <div>
                <Button
                    onClick={() => {
                        this.props.onClose();
                    }}
                >
                    Cancel
                </Button>
                <Button
                    color='primary'
                    onClick={() => {
                        this.props.disableApp();
                    }}
                >
                    Ok
                </Button>
            </div>
        } else {
            actions = <div>
                <Button
                    onClick={() => {
                        this.props.onClose();
                    }}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    disabled={this.props.ui.disableButton}
                    onClick={() => {
                        this.props.onSubmit(this.state.onCallAirApiKey);
                    }}
                >
                    {this.determineCallToAction()}
                </Button>
            </div>
        }

        var linkContent;
        var title;
        var maxWidth = 'xl';
        var doneContent;


        if (this.props.ui.done) {
            title = "We have successfully connected to your OnCallair account";
            doneContent = "You can now now create OnCall Air proposals in Housecall Pro";
            maxWidth = 'sm';
        } if (this.props.appEnabled) {
            title = "Are you sure you want to disconnect from OnCallair?"
            doneContent = ""
        } else {
            maxWidth = 'md';
            title = 'Visit your OnCall Air account to get you OnCallair API connection key. Then copy/paste it in the text field below';
            linkContent = (
                <div>
                    {errorBar}
                    <TextField
                        autoFocus={true}
                        placeholder="OnCall Air API connection key"
                        label="Copy & paste here"
                        defaultValue={this.props.ui.onCallAirApiKey}
                        fullWidth={true}
                        onChange={(event) => {
                            this.setState({onCallAirApiKey: event.target.value})
                        }}
                    />
                </div>
            );
        }

        return (
            <Dialog
                key="1"
                open={this.props.ui.open}
                onClose={() => {
                    this.props.onClose();
                }}
                maxWidth={maxWidth}
            >
                <DialogTitle>
                    {title}
                </DialogTitle>
                <DialogContent>
                    {linkContent}
                    {doneContent}
                </DialogContent>
                <DialogActions>
                    {actions}
                </DialogActions>
            </Dialog>
        )
    }

}

export default compose(
    ui({
        state: {
            open: false,
            done: false,
            disableButton: false,
            yelpBusinessUrl: null,
            errorMessage: '',
            setupBookingWindows: false,
            businessHours: [{
                days: [],
                start_value: 14,
                end_value: 34
            }]

        },
        reducer: (state, action) => {
            switch (action.type) {
                case OPEN_ON_CALL_AIR_DIALOG:
                    return state.set('open', true);
                case CLOSE_ON_CALL_AIR_DIALOG:
                    return state.set('open', false);
                case SET_ON_CALL_AIR_API_KEY:
                    console.log(action.onCallAirApiKey)
                    return state.set('onCallAirApiKey', action.onCallAirApiKey);
                case SUBMIT_FINISHED:
                    return state.set('done', true)
                        .set('disableButton', false)
                case SET_BUTTON_ENABLED:
                    return state.set('disableButton', action.status);
                case SET_ERROR_MESSAGE:
                    return state.set('errorMessage', action.message);
            }
            return state;
        }
    }),
    connect(
        state => {
            return {
                appEnabled: state.appEnabled
            }
        },
        (dispatch, props) => ({
            onClose: () => {
                dispatch({type: CLOSE_ON_CALL_AIR_DIALOG})
            },
            getOnCallAirApiKey: () => {
                getOnCallAirApiKey()
                    .then((response) => {
                        dispatch({type: SET_ON_CALL_AIR_API_KEY, onCallAirApiKey: response.data.api_key});
                    });
            },
            onSubmit: (onCallAirApiKey) => {
                console.log(onCallAirApiKey)
                updateOnCallAirApiKey(onCallAirApiKey)
                    .then((response) => {
                        dispatch({type: SUBMIT_FINISHED});
                        dispatch({type: CLOSE_ON_CALL_AIR_DIALOG})
                        dispatch(setAppEnabled());
                    })
                    .catch((error) => {
                        if (isPresent(error.message)) {
                            dispatch({type: SET_ERROR_MESSAGE, message: error.message});
                        }
                        dispatch({type: SET_BUTTON_ENABLED, enabled: true})
                    });

            },
            disableApp: () => {
                disableOnCallAir()
                    .then((response) => {
                        dispatch({type: CLOSE_ON_CALL_AIR_DIALOG})
                        dispatch(setAppDisabled())
                    })
                    .catch((error) => {
                        if (isPresent(error.message)) {
                            dispatch({type: SET_ERROR_MESSAGE, message: error.message});
                        }
                    })
            }
        })
    )
)(OnCallAirDialog)
